import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    carNumArr: [],
    carNumArr_rg: [],
    phoneNumber: '0757-22190762',
  },
  mutations: {
    SET_CAR_NUM_ARR: (state, carNumArr) => {
      state.carNumArr = carNumArr
    },
    SET_CAR_NUM_ARR_RG: (state, carNumArr) => {
      state.carNumArr_rg = carNumArr
    },
  },
  actions: {
    changeCarNumArr ({ commit }, val) {
      commit("SET_CAR_NUM_ARR", val);
    },
    changeCarNumArrRg ({ commit }, val) {
      commit("SET_CAR_NUM_ARR_RG", val);
    },
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js